<template>
    <v-container v-if="visible">
        <div class="mb-3" :class="wrapperClass">
            <img :src="url" :alt="altLabel" class="module-personalization-banner__img" />
        </div>
    </v-container>
</template>

<script>
import { mapStores } from 'pinia';
import { useMainStore } from '@/stores/mainStore';

export default {
    props: {
        position: {
            type: String,
            required: true,
            validator: (value) => ['top', 'bottom'].includes(value),
        },
    },
    computed: {
        ...mapStores(useMainStore),
        url() {
            const key = `banner_${this.position}_url`;
            return (this.mainStore.module.personalization[key] || '').trim();
        },
        inCard() {
            const key = `banner_${this.position}_in_card`;
            return !!this.mainStore.module.personalization[key];
        },
        visible() {
            return this.url !== '' && !this.isAdminRoute;
        },
        isAdminRoute() {
            return (this.$route.path || '').includes('/admin');
        },
        wrapperClass() {
            return this.inCard ? 'content-container module-personalization-banner' : 'module-personalization-banner';
        },
        altLabel() {
            return this.position === 'top' ? 'Bandeau haut du module' : 'Bandeau bas du module';
        },
    },
};
</script>

<style lang="scss" scoped>
.module-personalization-banner {
    display: flex;
    justify-content: center;
    align-items: center;
}

.module-personalization-banner__img {
    display: block;

    width: auto;
    max-height: 250px;
    height: auto;
    border-radius: 4px;
}
</style>
